import { apiServiceClient } from '../frameworkClient';

const adminServiceClient = apiServiceClient(
  process.env.REACT_APP_ADMIN_URL || 'framework/AdminService',
);

const endpoints = {
  blockUser: 'blockUser',
  changeContractToSwap: 'changeContractToSwap',
  createStore: 'createStore',
  createUser: 'createUser',
  createWlDevice: 'createWlDevice',
  disableWlDevice: 'disableWlDevice',
  getUser: 'getUser',
  getVouchers: 'getVouchers',
  listAccessories: 'listAccessories',
  listDevices: 'listDevices',
  listStores: 'listStores',
  listUsers: 'listUsers',
  resetUserPassword: 'resetUserPassword',
  unblockUser: 'unblockUser',
  updateStore: 'updateStore',
  updateUser: 'updateUser',
  updateWlDevice: 'updateWlDevice',
  uploadFile: 'uploadFile',
};

export const blockUser = async ({ userID, sessionID }, options) => {
  return adminServiceClient(
    endpoints.blockUser,
    { userID, sessionID },
    options,
  );
};

export const changeContractToSwap = async (
  { swapStatus, uuids, sessionID },
  options,
) => {
  return await adminServiceClient(
    endpoints.changeContractToSwap,
    {
      swapStatus,
      uuids,
      sessionID,
    },
    options,
  );
};

export const createStore = async ({ store, sessionID }, options) => {
  return adminServiceClient(
    endpoints.createStore,
    { store, sessionID },
    options,
  );
};

export const createUser = async ({ user, sessionID }, options) => {
  return adminServiceClient(endpoints.createUser, { user, sessionID }, options);
};

export const createWlDevice = async ({ wlDevice, sessionID }, options) => {
  return adminServiceClient(
    endpoints.createWlDevice,
    { wlDevice, sessionID },
    options,
  );
};

export const disableWlDevice = async ({ wlDeviceID, sessionID }, options) => {
  return adminServiceClient(
    endpoints.disableWlDevice,
    {
      wlDeviceID,
      sessionID,
    },
    options,
  );
};

export const getUser = async ({ userID, sessionID }, options) => {
  return adminServiceClient(endpoints.getUser, { userID, sessionID }, options);
};

export const getVouchers = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.getVouchers, { sessionID }, options);
};

export const listAccessories = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.listAccessories, { sessionID }, options);
};

export const listDevices = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.listDevices, { sessionID }, options);
};

export const listStores = async ({ wlID, sessionID }, options) => {
  return adminServiceClient(endpoints.listStores, { wlID, sessionID }, options);
};

export const listUsers = async ({ sessionID }, options) => {
  return adminServiceClient(endpoints.listUsers, { sessionID }, options);
};

export const resetUserPassword = async ({ userID, sessionID }, options) => {
  return adminServiceClient(
    endpoints.resetUserPassword,
    { userID, sessionID },
    options,
  );
};

export const unblockUser = async ({ userID, sessionID }, options) => {
  return adminServiceClient(
    endpoints.unblockUser,
    { userID, sessionID },
    options,
  );
};

export const updateStore = async ({ store, sessionID }, options) => {
  return adminServiceClient(
    endpoints.updateStore,
    { store, sessionID },
    options,
  );
};

export const updateUser = async ({ user, sessionID }, options) => {
  return adminServiceClient(endpoints.updateUser, { user, sessionID }, options);
};

export const updateWlDevice = async ({ wlDevice, sessionID }, options) => {
  return adminServiceClient(
    endpoints.updateWlDevice,
    { wlDevice, sessionID },
    options,
  );
};

export const uploadFile = async (
  { file, type, campaignCode, sessionID },
  options,
) => {
  return adminServiceClient(
    endpoints.uploadFile,
    {
      file,
      type,
      campaignCode,
      sessionID,
    },
    options,
  );
};

export default {
  blockUser,
  changeContractToSwap,
  createStore,
  createUser,
  createWlDevice,
  disableWlDevice,
  endpoints,
  getUser,
  getVouchers,
  listAccessories,
  listDevices,
  listStores,
  listUsers,
  resetUserPassword,
  unblockUser,
  updateStore,
  updateUser,
  updateWlDevice,
  uploadFile,
};
